module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "workOrderInfo"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('p', {
    staticClass: "headerT fl",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("工单信息")]), _vm._v(" "), _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "margin": "-5px 0 0 0px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("已完成")]), _vm._v(" "), _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "margin": "-5px 0 0 20px"
    },
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("工程师：李某某")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-star-off fl",
    staticStyle: {
      "font-size": "20px",
      "margin-left": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('el-form', {
    ref: "orderInfoForm",
    attrs: {
      "model": _vm.orderInfoForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工单编号",
      "prop": "orderNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.orderNumber),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderNumber", $$v)
      },
      expression: "orderInfoForm.orderNumber"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.orderInfoForm.orderNumber, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工单类型",
      "prop": "orderType"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.orderType),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderType", $$v)
      },
      expression: "orderInfoForm.orderType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渠道来源",
      "prop": "orderSource"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.orderSource),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderSource", $$v)
      },
      expression: "orderInfoForm.orderSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.clientName),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "clientName", $$v)
      },
      expression: "orderInfoForm.clientName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.clientPhone),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "clientPhone", $$v)
      },
      expression: "orderInfoForm.clientPhone"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.orderInfoForm.clientPhone, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市区"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.sheng),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "sheng", $$v)
      },
      expression: "orderInfoForm.sheng"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.shi),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "shi", $$v)
      },
      expression: "orderInfoForm.shi"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.qu),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "qu", $$v)
      },
      expression: "orderInfoForm.qu"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.clientAddress),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "clientAddress", $$v)
      },
      expression: "orderInfoForm.clientAddress"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.orderInfoForm.sheng + _vm.orderInfoForm.shi + _vm.orderInfoForm.qu + _vm.orderInfoForm.clientAddress, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约时间"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.appoTime),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "appoTime", $$v)
      },
      expression: "orderInfoForm.appoTime"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("维修信息")]), _vm._v(" "), _c('el-form', {
    ref: "orderInfoForm",
    attrs: {
      "model": _vm.orderInfoForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "IMEI",
      "prop": "IMEI"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.IMEI),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "IMEI", $$v)
      },
      expression: "orderInfoForm.IMEI"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌",
      "prop": "brand"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.brand),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "brand", $$v)
      },
      expression: "orderInfoForm.brand"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品类",
      "prop": "category"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.category),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "category", $$v)
      },
      expression: "orderInfoForm.category"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "型号",
      "prop": "model"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.model),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "model", $$v)
      },
      expression: "orderInfoForm.model"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色",
      "prop": "color"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.color),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "color", $$v)
      },
      expression: "orderInfoForm.color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障",
      "prop": "fault"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.fault),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "fault", $$v)
      },
      expression: "orderInfoForm.fault"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("支付信息")]), _vm._v(" "), _c('el-form', {
    ref: "orderInfoForm",
    attrs: {
      "model": _vm.orderInfoForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障金额",
      "prop": "faultPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.faultPrice),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "faultPrice", $$v)
      },
      expression: "orderInfoForm.faultPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "折扣",
      "prop": "discount"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "discount", $$v)
      },
      expression: "orderInfoForm.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应付金额",
      "prop": "payAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "payAmount", $$v)
      },
      expression: "orderInfoForm.payAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实付金额",
      "prop": "realAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.realAmount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "realAmount", $$v)
      },
      expression: "orderInfoForm.realAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收钱吧流水号",
      "prop": "moneyNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "payAmount", $$v)
      },
      expression: "orderInfoForm.payAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "到账情况",
      "prop": "moneyStutas"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.moneyStutas),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "moneyStutas", $$v)
      },
      expression: "orderInfoForm.moneyStutas"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('el-button-group', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, _vm._l((_vm.orderStates), function(item, index) {
    return _c('el-button', {
      key: index,
      class: {
        activeBtn: _vm.activeBtnIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.changeState(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), (_vm.activeBtnIndex == 0) ? _c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("\n      提交为\n      "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.DetermineSave()
      }
    }
  }, [_vm._v("已确认")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.temporarySave()
      }
    }
  }, [_vm._v("暂存")])], 1)], 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.pageStatus) + "\n      "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.goOnSave()
      }
    }
  }, [_vm._v("留在当前页面")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeSave()
      }
    }
  }, [_vm._v("离开当前页面")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitEditor()
      }
    }
  }, [_vm._v("提交")])], 1) : _vm._e(), _vm._v(" "), (_vm.activeBtnIndex == 1) ? _c('el-row', [_c('ul', _vm._l((_vm.procurementEvents), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "eventLi"
    }, [(item.createTime) ? _c('span', {
      staticClass: "createTime childSpan clearfix"
    }, [_c('i', {
      staticClass: "fl"
    }), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm.formatTime(item.createTime)))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.details) ? _c('span', {
      staticClass: "details childSpan"
    }, [_vm._v(_vm._s(item.details)), _c('br')]) : _vm._e(), _vm._v(" "), (item.attribute1) ? _c('span', {
      staticClass: "attribute1 childSpan"
    }, [_vm._v("\n            " + _vm._s(item.attribute1.substring(0, item.attribute1.lastIndexOf('：') + 1)) + "\n            "), _c('span', {
      staticClass: "orderId"
    }, [_vm._v("\n            " + _vm._s(item.attribute1.substring(item.attribute1.lastIndexOf('：') + 1 )) + "\n            ")]), _c('br')]) : _vm._e(), _vm._v(" "), (item.attribute2) ? _c('span', {
      staticClass: "attribute2 childSpan"
    }, [_vm._v("\n            " + _vm._s(item.attribute2.substring(0, item.attribute2.lastIndexOf('：') + 1)) + "\n            "), _c('span', {
      staticClass: "orderId"
    }, [_vm._v("\n            " + _vm._s(item.attribute2.substring(item.attribute2.lastIndexOf('：') + 1 )) + "\n            ")]), _c('br')]) : _vm._e(), _vm._v(" "), (item.attribute3) ? _c('span', {
      staticClass: "attribute3 childSpan"
    }, [_vm._v("\n            " + _vm._s(item.attribute3.substring(0, item.attribute3.lastIndexOf('：') + 1)) + "\n            "), _c('span', {
      staticClass: "orderId"
    }, [_vm._v("\n            " + _vm._s(item.attribute3.substring(item.attribute3.lastIndexOf('：') + 1 )) + "\n            ")]), _c('br')]) : _vm._e()])
  }), 0)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-80a1a966","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workOrder/workOrderInfo.vue
// module id = 1712
// module chunks = 0